module.exports = __webpack_public_path__ + "img/layout_right_1.ee0afc61.jpg";